import React from 'react';
import { ImageField, ImageInput, useNotify } from 'react-admin';
import ImageInformations from '../ImageInformations';
import { __t } from '../../i18n/t';

/**
 * Acompanha o `payload.maxBytes` das rotas de parceiro no pontuax-backend. Acima dele o Hapi
 * recusa a requisição inteira com 413 antes de chegar no handler, e a mensagem que sobra pro
 * usuário é a do Hapi ("Payload content length greater than maximum allowed: ..."). Tela cuja
 * rota tem outro limite passa o `maxSize` dela.
 */
export const MAX_IMAGE_UPLOAD_SIZE = 5 * 1024 * 1024;

const ACCEPTED_IMAGE_TYPES = { 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] };

interface ImageUploadInputProps {
  source?: string;
  label?: string;
  maxSize?: number;
  informationsPosition?: number;
}

const ImageUploadInput: React.FC<ImageUploadInputProps> = ({
  source = 'imagefile',
  label = 'Imagem',
  maxSize = MAX_IMAGE_UPLOAD_SIZE,
  informationsPosition,
}) => {
  const notify = useNotify();
  const maxSizeMb = Math.floor(maxSize / (1024 * 1024));

  return (
    <>
      <ImageInput
        source={source}
        label={label}
        accept={ACCEPTED_IMAGE_TYPES}
        maxSize={maxSize}
        options={{
          // O react-dropzone descarta o arquivo recusado em silêncio e o ImageInput ainda zera o
          // campo, então sem este aviso o usuário escolhe a imagem e não acontece nada.
          onDrop: (_accepted, rejected) => {
            if (rejected.length === 0) { return; }
            const tooLarge = rejected[0].errors.some(error => error.code === 'file-too-large');
            notify(
              tooLarge
                ? __t('A imagem passa do limite de %{size}MB. Reduza o arquivo e tente novamente.', { size: maxSizeMb })
                : __t('Formato de arquivo não aceito. Envie uma imagem .jpeg, .png, .gif ou .webp.'),
              { type: 'warning' },
            );
          },
        }}
      >
        <ImageField source="src" />
      </ImageInput>
      <ImageInformations maxSizeMb={maxSizeMb} position={informationsPosition} />
    </>
  );
};

export default ImageUploadInput;
